import React, { useEffect, useState } from 'react';
import Styled from './AdminModal.styled';
import { Modal } from 'react-bootstrap';
import Row from 'components/Row';
import PerfilUsuario from 'models/perfil/PerfilUsuario';
import { fetchRoleDescription } from 'core/util/KeycloakHelp';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import Select, { SelectOptionType } from 'components/Select';
import { Input } from 'antd';
import { RoleEnum, RoleList } from 'enums/RoleEnum';


export interface IAdminModalEdit {
    show: boolean;
    onHide: () => void;
    perfil: PerfilUsuario;
    onSubmit: (keycloak: string, newRole: string | null, newOccupation: string | null) => Promise<void>;
}

const AdminModalEdit = ({ show, onHide, perfil, onSubmit }: IAdminModalEdit) => {
    const [submitting, setSubmitting] = useState<boolean>(false);
    const [roleSelected, setRoleSelected] = useState<RoleEnum | null>(null);
    const [occupation, setOccupation] = useState<string | null>(null);

    const getRoles = (): SelectOptionType[] => {
        const _roles = RoleList.map(role => ({ value: role.value, label: role.label } as SelectOptionType)).filter(
            o => o.value != perfil.role
        );

        return _roles;
    };

    const handleRoleChange = (value: string, label: string) => {
        setRoleSelected(value as RoleEnum);
        setOccupation(label);
    };

    const hide = () => {
        setRoleSelected(null);
        setSubmitting(false);
        setOccupation(null);
        onHide();
    };

    return (
        <Modal show={show} onHide={hide}>
            <Styled.Container>
                <Row justify="space-between">
                    <Styled.Title>Alterar Perfil</Styled.Title>
                    <Styled.CloseIconContainer>
                        <AiOutlineCloseCircle onClick={() => hide()} />
                    </Styled.CloseIconContainer>
                </Row>
                <br />
                <Styled.Text>Usuário: <strong>{perfil.apelido}</strong></Styled.Text>
                <Styled.Text>Principal Perfil (Role): <strong>{fetchRoleDescription(perfil.role) || perfil.role || perfil.ocupacao}</strong></Styled.Text>
                <Styled.Text>Principal ocupação: <strong>{perfil.ocupacao}</strong></Styled.Text>
                <br />
                <br />
                <Styled.TextStrong>Novo perfil:</Styled.TextStrong>
                <Select isSmall itens={getRoles()} width="100%" onSelected={o => handleRoleChange(String(o.value), String(o.label))} />
                <br />
                <br />
                <Styled.TextStrong>Nova ocupação:</Styled.TextStrong>
                <Input
                    size="large"
                    value={occupation || ''}
                    onChange={e => setOccupation(e.target.value)}
                    placeholder="Digite a nova ocupação"
                />
                <br />
                <br />
                <Row justify="space-between">
                    <Styled.CancelButton onClick={hide}>Cancelar</Styled.CancelButton>
                    <Styled.PrimaryButton
                        onClick={async () => {
                            setSubmitting(true);
                            await onSubmit(perfil.keycloakId, roleSelected, occupation);
                            setSubmitting(false);
                        }}
                        disabled={(roleSelected === null && occupation === null) || submitting}
                    >
                        {submitting ? 'Alterando' : 'Alterar Perfil'}
                    </Styled.PrimaryButton>
                </Row>
            </Styled.Container>
        </Modal>
    );
};

export default AdminModalEdit;
